import { sendTrackingEventBatch } from "./base-tracker"

const store = {
  queue: [],
  interval: null,
  visibilityListener: null,
}

const sendEvents = () => {
  if (store.queue.length === 0) {
    return
  }

  const eventsToSend = [...store.queue]
  store.queue = []

  sendTrackingEventBatch(eventsToSend)
}

export const addEventToQueue = (event, flushQueue = false) => {
  store.queue.push(event)

  if (store.queue.length >= 10 || flushQueue) {
    sendEvents()
  }

  // On first event tracking, initialize listeners
  if (!store.interval) {
    store.interval = setInterval(() => {
      sendEvents()
    }, 120000) // Send every two minutes
  }

  if (!store.visibilityListener) {
    store.visibilityListener = window.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        sendEvents()
      }
    })
  }
}
